import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsPage = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      
      <main style={{ 
        padding: '40px 20px', 
        maxWidth: '800px', 
        margin: '0 auto',
        flex: '1'
      }}>
        <h1 style={{ color: '#2c3e50', marginBottom: '30px' }}>Terms of Use</h1>

        <div style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '15px' }}>1. Entertainment Purpose Only</h2>
          <p style={{ color: '#7f8c8d', lineHeight: '1.6' }}>
            This product is for entertainment purposes only. It does not provide medical advice, diagnosis, or treatment. 
            The information provided through this service is generated by artificial intelligence and should not be 
            considered as professional medical advice.
          </p>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '15px' }}>2. No Medical Advice</h2>
          <p style={{ color: '#7f8c8d', lineHeight: '1.6' }}>
            The content and information provided through this service are not intended to replace professional 
            medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified 
            health provider with any questions you may have regarding a medical condition.
          </p>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '15px' }}>3. AI-Generated Content</h2>
          <p style={{ color: '#7f8c8d', lineHeight: '1.6' }}>
            The information provided through this service is generated by artificial intelligence systems. 
            While we strive for accuracy, AI systems may produce incorrect or misleading information. Users 
            acknowledge and accept this limitation.
          </p>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '15px' }}>4. User Responsibility</h2>
          <p style={{ color: '#7f8c8d', lineHeight: '1.6' }}>
            By using this service, you accept full responsibility for any consequences that may arise from 
            your use of the information provided. You agree not to hold the creators of the system or the 
            company responsible for any outcomes or decisions made based on the information provided.
          </p>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '15px' }}>5. Limitation of Liability</h2>
          <p style={{ color: '#7f8c8d', lineHeight: '1.6' }}>
            The creators of this system and the company shall not be liable for any direct, indirect, 
            incidental, special, consequential, or exemplary damages resulting from your use of or inability 
            to use the service.
          </p>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '15px' }}>6. No Warranties</h2>
          <p style={{ color: '#7f8c8d', lineHeight: '1.6' }}>
            The service is provided "as is" without any warranties of any kind, either express or implied. 
            We do not warrant that the service will be uninterrupted, error-free, or free of viruses or 
            other harmful components.
          </p>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#2c3e50', marginBottom: '15px' }}>7. Changes to Terms</h2>
          <p style={{ color: '#7f8c8d', lineHeight: '1.6' }}>
            We reserve the right to modify these terms at any time. Your continued use of the service 
            following any changes indicates your acceptance of the new terms.
          </p>
        </div>

        <div style={{ 
          padding: '20px', 
          backgroundColor: '#f8f9fa', 
          borderRadius: '5px',
          marginTop: '40px'
        }}>
          <p style={{ color: '#7f8c8d', lineHeight: '1.6', marginBottom: '15px' }}>
            By using this service, you acknowledge that you have read, understood, and agree to be bound 
            by these terms of use.
          </p>
          <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <input type="checkbox" style={{ width: '20px', height: '20px' }} />
            <span style={{ color: '#7f8c8d' }}>
              I agree to the Terms of Use
            </span>
          </label>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsPage; 